import React, { FC, useContext } from "react";
import { GlobalContext } from "../../context/globalContext/globalContext";
import AuditLogement from "../../assets/icons/auditlogement.png";
import GuichetsEnergie from "../../assets/icons/guichets_energie_1.jpg";
import CertificatPeb from "../../assets/icons/certificat_peb.png";
import Walloreno from "../../assets/icons/walloreno.png";
import BlueArrow from "../../assets/icons/questionsForm/step1/arrow-down-blue.svg";

interface ProjectsInterface {}

const Projects: FC<ProjectsInterface> = () => {
  // global state
  const { state }: any = useContext(GlobalContext);
  return (
    <div className="">
      <div className="mr-2 ml-2  mx-auto pt-2 pb-[70px] flex justify-center">
        <div className="w-[100%] flex flex-row">
          {/* left side */}
          <div className="pr-2 w-6/12">
            <div className="w-full bg-white border-[#E1F4FB] border-2 rounded-xl p-6">
              <div className="flex w-full">
                <div className="w-4/12">
                  <img src={AuditLogement} className="ml-[-7px]" alt="" />
                </div>
                <div className="w-full w-8/12">
                  <div>
                    <p className="text-[#3A484D] text-left text-[22px] font-semibold">
                      {state?.language?.result?.informations?.box31}
                    </p>
                  </div>
                  <div className="block">
                    <div className="flex justify-end">
                      <a
                        className="text-[#00A3DA] text-right text-[19px] pt-4 font-semibold flex items-center"
                        href="https://energie.wallonie.be/home/contacts/auditeurs-logement.html#BBOX=16938.544494599744,305318.838390622,33470.23083556723,151627.43519105203"
                        target="_blank"
                        rel="noreferrer"
                      >
                        <span className="pr-2">
                          <img
                            src={BlueArrow}
                            alt=""
                            className="h-7 rotate-[-90deg]"
                          />
                        </span>
                        <p className="w-[97%]">
                          {state?.language?.result?.informations?.box32}
                        </p>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <div>
                <div className="flex px-1">
                  <span className="w-3 mt-2 h-3 bg-[#00A3DA] rounded-full"></span>
                  <p className="text-[#3A484D] text-[19px] m-0 pl-2 w-11/12">
                    {state?.language?.result?.informations?.box32Point1}
                  </p>
                </div>
                <div className="flex px-1">
                  <span className="w-3 mt-2 h-3 bg-[#00A3DA] rounded-full"></span>
                  <p className="text-[#3A484D] text-[19px] m-0 pl-2 w-11/12">
                    {state?.language?.result?.informations?.box32Point2}
                  </p>
                </div>
                <div className="flex px-1">
                  <span className="w-3 h-3 mt-2 bg-[#00A3DA] rounded-full"></span>
                  <p className="text-[#3A484D] text-[19px] m-0 pl-2 w-11/12">
                    {state?.language?.result?.informations?.box32Point3}
                  </p>
                </div>
              </div>
            </div>
            <div className="w-full block bg-white border-2 border-[#E1F4FB] rounded-xl p-6 mt-4">
              <div className="flex w-full">
                <div className="w-full">
                  <div>
                    <p className="text-[#3A484D] text-left text-[22px] font-semibold">
                      {state?.language?.result?.informations?.box1New}
                    </p>
                  </div>
                  <div className="flex justify-center pl-10 pt-3">
                    <img
                      src={GuichetsEnergie}
                      className="h-[6.5rem]"
                      alt=""
                    />
                  </div>
                  <div className="flex justify-start pt-2">
                    <a
                      className="text-[#00A3DA] text-left text-[19px] pt-4 font-semibold flex items-center"
                      href="https://energie.wallonie.be/home/contacts/guichets-energie-wallonie.html"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <span className="pr-2">
                        <img
                          src={BlueArrow}
                          alt=""
                          className="h-7 rotate-[-90deg]"
                        />
                      </span>
                      <p className="w-[96%]">
                        {state?.language?.result?.informations?.box14}
                      </p>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* right side */}
          <div className="pl-2 w-6/12 pt-0">
            <div className="w-full block bg-white border-2  border-[#E1F4FB] rounded-xl p-6">
              <div className="flex w-full">
                <div className="w-4/12">
                  <img src={CertificatPeb} className="ml-[-10px]" alt="" />
                </div>
                <div className="w-full w-8/12">
                  <div>
                    <p className="text-[#3A484D] text-left text-[22px] font-semibold">
                      {state?.language?.result?.informations?.box4}
                    </p>
                  </div>
                  <div className="flex justify-end">
                    <a
                      className="text-[#00A3DA] text-left text-[19px] pt-4 font-semibold flex items-center"
                      href="https://energie.wallonie.be/home/contacts/certificateurs/certificateurs-peb-de-batiment-residentiel.html#BBOX=16938.544494599744,305318.838390622,33470.23083556723,151627.43519105203"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <span className="pr-2">
                        <img
                          src={BlueArrow}
                          alt=""
                          className="h-7 rotate-[-90deg]"
                        />
                      </span>
                      <p className="w-[96%]">
                        {state?.language?.result?.informations?.box41}
                      </p>
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div className="w-full bg-white border-2 border-[#E1F4FB] rounded-xl p-6 mt-4">
              <div className="flex w-full">
                <div className="w-full">
                  <div>
                    <p className="text-[#3A484D] text-left text-[22px] font-semibold px-5">
                      {state?.language?.result?.informations?.box5A}
                      <a
                        href="https://energie.wallonie.be/files/PEB/B%c3%a2timents%20r%c3%a9sidentiels/R%c3%a9novation/Outils/Publications/Walloreno/brochureWalloreno_2026.pdf"
                        className="text-[#00A3DA]"
                        target="_blank"
                        rel="noreferrer"
                      >
                        {state?.language?.result?.informations?.box5B}
                      </a>
                      {state?.language?.result?.informations?.box5C}
                    </p>
                  </div>
                  <div className="flex justify-center pt-2">
                    <img src={Walloreno} className="h-40" alt="" />
                  </div>
                  <div className="flex justify-start px-5">
                    <a
                      className="text-[#00A3DA] text-left text-[19px] pt-2 font-semibold flex items-center"
                      href="https://energie.wallonie.be/home/performance-energetuique-des-batiments/batiments-residentiels/renovation-walloreno/outils/publications/guide-pratique--renover-pour-consommer-moins-denergie.html"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <span className="pr-2">
                        <img
                          src={BlueArrow}
                          alt=""
                          className="h-7 rotate-[-90deg]"
                        />
                      </span>
                      <p className="w-[96%]">
                        {state?.language?.result?.informations?.box22}
                      </p>
                    </a>
                  </div>
                  <div className="pt-2">
                    <div className="flex">
                      <span className="w-3 h-3 bg-[#00A3DA] rounded-full mt-2"></span>
                      <p className="text-[#3A484D] text-[19px] m-0 px-2 w-11/12">
                        {state?.language?.result?.informations?.box22Point1}
                      </p>
                    </div>
                    <div className="flex py-1">
                      <span className="w-3 h-3 bg-[#00A3DA] rounded-full mt-2"></span>
                      <p className="text-[#3A484D] text-[19px] m-0 px-2 w-11/12">
                        {state?.language?.result?.informations?.box22Point2}
                      </p>
                    </div>
                    <div className="flex">
                      <span className="w-3 h-3 bg-[#00A3DA] rounded-full mt-2"></span>
                      <p className="text-[#3A484D] text-[19px] m-0 px-2 w-11/12">
                        {state?.language?.result?.informations?.box22Point3}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Projects;
